/* eslint-disable */
import React, { useState } from 'react';
import './services.css';

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="services section" id="services">
      <h2 className="section_title">Services</h2>
      <span className="section_subtitle">
        What I offer
      </span>

      <div className="services_container container grid">
        <div className="services_content">
          <div>
            <i className="uil uil-web-grid services_icon" />
            <h3 className="services_title">
              Front-End
              <br />
              {' '}
              Development
            </h3>

            <span className="services_button" onClick={() => toggleTab(1)}>
              View more
              {' '}
              <i className="uil uil-arrow-right services_button-icon" />
            </span>

            <div className={toggleState === 1 ? 'services_modal active_modal' : 'services_modal'}>
              <div className="services_modal-content">
                <i onClick={() => toggleTab(0)} className="uil uil-times services_modal-close" />

                <h3 className="services_modal-title"> Front-End Development</h3>
                <p className="services_modal-description">Services with more than 1 year+ hands-on Experience in building and designing innovative software solution </p>

                <ul className="services_modal-services grid">
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Develop interactive and responsive user interfaces using JavaScript (ES6), React, Redux, Bootstrap, and SASS.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Utilize Figma for wireframing and prototyping UI designs.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Ensure web accessibility and SEO optimization of web applications.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Conduct cross-browser testing and debugging using Chrome DevTools.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Implement performance optimization techniques to improve website speed.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Deploy web applications to cloud platforms such as Heroku and Netlify.</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div className="services_content">
          <div>
            <i className="uil uil-arrow services_icon" />
            <h3 className="services_title">
              Back-End
              {' '}
              <br />
              Development
            </h3>

            <span className="services_button" onClick={() => toggleTab(2)}>
              View more
              {' '}
              <i className="uil uil-arrow-right services_button-icon" />
            </span>

            <div className={toggleState === 2 ? 'services_modal active_modal' : 'services_modal'}>
              <div className="services_modal-content">
                <i onClick={() => toggleTab(0)} className="uil uil-times services_modal-close" />

                <h3 className="services_modal-title">Back-End Development</h3>
                <p className="services_modal-description">Services with more than 1 year+ hands-on Experience in building and designing innovative software solution </p>

                <ul className="services_modal-services grid">
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Develop and manage databases using SQL and Postgresql.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Create and deploy RESTful APIs using Ruby on Rails.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Utilize RSpec for automated testing of backend functionality</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Utilize Git and GitHub for version control and collaboration.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Implement performance optimization techniques to improve API speed.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Conduct debugging and troubleshooting of backend issues.</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
        <div className="services_content">
          <div>
            <i className="uil uil-edit services_icon" />
            <h3 className="services_title">
              Project Management and
              <br />
              {' '}
              Mentoring

            </h3>

            <span className="services_button" onClick={() => toggleTab(3)}>
              View more
              {' '}
              <i className="uil uil-arrow-right services_button-icon" />
            </span>

            <div className={toggleState === 3 ? 'services_modal active_modal' : 'services_modal'}>
              <div className="services_modal-content">
                <i onClick={() => toggleTab(0)} className="uil uil-times services_modal-close" />

                <h3 className="services_modal-title">Project Management and Mentoring</h3>
                <p className="services_modal-description">Services with more than 1 year+ hands-on Experience in building and designing innovative software solution. </p>

                <ul className="services_modal-services grid">
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Manage software development projects to ensure timely and high-quality delivery.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Conduct project planning, execution, and monitoring using agile methodologies.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Provide mentorship and guidance to junior developers to improve their skills.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Conduct remote pair-programming to help junior developers solve complex problems.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Utilize effective communication and collaboration tools such as Slack and Trello to facilitate teamwork.</p>
                  </li>
                  <li className="services_modal-service">
                    <i className="uil uil-check-circle services_modal-icon" />
                    <p className="services_modal-info">Conduct code reviews and provide feedback to improve code quality.</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;
